<template>
  <div class="grid-x flex-grow">
    <div class="cell auto cell-block-y flex flex-col flex-grow">
      <Loading :loading="waitPending">
        <div class="flex flex-col">
          <Table
            :columns="columns"
            :rows="payload"
            :sort-options="{
              enabled: false,
            }"
            :busy="waitPending"/>
        </div>
      </Loading>
    </div>
  </div>
</template>

<script type="text/jsx">
import { mapActions, mapState } from 'vuex';
import Table from '@/components/Table.vue';
import Check from '@/components/Check.vue';
import Loading from '@/components/Loading.vue';

export default {
  components: {
    Table,
    Loading,
  },
  computed: {
    ...mapState({
      payload: (state) => state.settings.workingRegions,
    }),
    columns() {
      return [
        {
          label: 'Доступные регионы',
          field: 'name',
          sortable: false,
        },
        {
          label: 'Количество партнеров',
          field: 'contractorsCount',
          tdClass: 'font-bold',
          cell: ({ row }) => <b>
            { this.$numeral(row.contractorsCount).format('0,0') }
          </b>,
          sortable: false,
        },
        {
          label: 'Активация регионов',
          field: ' ',
          sortable: false,
          cell: ({ row }) => <Check
            disabled={this.$wait.is(`update.working.regions.${row.id}`)}
            value={!!row.active}
            onInput={(event) => { this.onChange(event, row); }}/>,
        },
        {
          label: '',
          field: ' ',
          width: '100%',
          sortable: false,
        },
      ];
    },
    waitPending() {
      return this.$wait.is('fetch.working.regions');
    },
  },
  methods: {
    ...mapActions({
      fetch: 'settings/ACT_FETCH_WORKING_REGIONS',
      update: 'settings/ACT_UPDATE_WORKING_REGIONS',
    }),
    onChange(event, { id }) {
      this.update({
        id,
        value: event,
      });
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
